import * as React from 'react';
import { PrimaryContentType, StyleVariant } from '../AmorgMenuTypes';
import { TextContent } from '../baseContentTypes/TextContent';
import { TextWithSubtextContent } from '../baseContentTypes/TextWithSubtextContent';

type PrimaryContentProps = PrimaryContentType &
{
    styleVariant:StyleVariant,
    isHovering:boolean,
    onClick?:()=>void
}

export function PrimaryContent(props:PrimaryContentProps):JSX.Element
{
    let subtextStyleVariantOverride:StyleVariant = props.styleVariant;
    if(props.type === 'textWithSubtext'){
        if(props.subtextStyleVariantOverride)
            subtextStyleVariantOverride = props.subtextStyleVariantOverride;
    }

    return (
        <>
            {props.type === 'text' && 
                <TextContent 
                    type='text' text={props.text}
                    textAlign='left'
                    flex={props.flex}
                    styleVariant={props.styleVariantOverride || props.styleVariant}
                    isHovering={props.onClick && props.isHovering} />
            }

            {props.type === 'textWithSubtext' && 
                <TextWithSubtextContent 
                    type='textWithSubtext' 
                    text={props.text}
                    subtext={props.subtext}
                    flex={props.flex}
                    styleVariant={props.styleVariantOverride || props.styleVariant}
                    subtextStylevariant={subtextStyleVariantOverride}
                    isHovering={props.onClick && props.isHovering} />
            }
        </>
    );
}